export default __webpack_public_path__ + "static/media/logo_coop.9125e5f9.svg";